"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var mobx_1 = require("mobx");
exports.default = satcheljs_1.createStore('upNextViewState', {
    calendarItems: mobx_1.map(),
    isAgendaOpen: false,
    isExpansionOpen: false,
    weatherClickThrough: '',
    weatherDailyConditions: [],
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/store/store.js
// module id = 2935
// module chunks = 48